import { isProd } from "@utils";

import {
  CREATE_DIALOG,
  DIALOG_TYPES,
  EDIT_DIALOG,
  REACTIVATE_DIALOG,
  DEACTIVATE_DIALOG,
  BRANCH_DEPLOYER_FIELDS,
  VIEW_DETAILS_DIALOG,
  VIEW_DETAILS_FIELDS,
  BRANCH_DEPLOYER_PRODUCTION_FIELDS,
  BRANCH_DEPLOYER_WITH_CONFIG_ID_FIELDS
} from "./BranchDeployer.consts";

const updateValuesFromArray = (arr, obj) => {
  arr.forEach(item => {
    const key = Object.keys(obj).find(key => key === item.id);

    if (key !== undefined) {
      item.value = obj[key];
    }
  });
  return arr;
};

const cloneFieldsArray = (arr) => arr.map(item => ({ ...item }));

const useBranchDeployerDialog = ({ type, data }) => {
  const fields = isProd() ? BRANCH_DEPLOYER_PRODUCTION_FIELDS : BRANCH_DEPLOYER_WITH_CONFIG_ID_FIELDS;
  let dialogContent = {};

  if (type === DIALOG_TYPES.create.id) {
    dialogContent = {
      title: CREATE_DIALOG.title,
      subtitle: CREATE_DIALOG.subtitle,
      actionButtonText: CREATE_DIALOG.buttonText,
      data: cloneFieldsArray(fields)
    };
  } else if (type === DIALOG_TYPES.edit.id) {
    dialogContent = {
      title: EDIT_DIALOG.title,
      subtitle: EDIT_DIALOG.subtitle,
      actionButtonText: EDIT_DIALOG.buttonText,
      data: updateValuesFromArray(cloneFieldsArray(fields), data)
    };
  } else if (type === DIALOG_TYPES.reactivate.id) {
    dialogContent = {
      title: REACTIVATE_DIALOG.title,
      subtitle: REACTIVATE_DIALOG.subtitle.replace("$branchDeployerName", data.releaseName),
      actionButtonText: REACTIVATE_DIALOG.buttonText
    };
  } else if (type === DIALOG_TYPES.deactivate.id) {
    dialogContent = {
      title: DEACTIVATE_DIALOG.title,
      subtitle: DEACTIVATE_DIALOG.subtitle.replace("$branchDeployerName", data.releaseName),
      actionButtonText: DEACTIVATE_DIALOG.buttonText
    };
  } else if (type === DIALOG_TYPES.viewDetails.id) {
    dialogContent = {
      title: VIEW_DETAILS_DIALOG.title,
      data: updateValuesFromArray([...cloneFieldsArray(VIEW_DETAILS_FIELDS), ...cloneFieldsArray(BRANCH_DEPLOYER_FIELDS)], data)
    };
  }
  return { dialogContent };
};

export default useBranchDeployerDialog;
